<div class="semelhantes" (window:resize)="onResize($event)">
  @if (validImages.length > 0) {
  <div>
    <h4 class="titulo">Similares</h4>
    <mat-divider class="divider-margin"></mat-divider>
    <br>
    <swiper-container
      slides-per-view="auto"
      [attr.slides-per-group]="colunas"
      [attr.navigation]="true"
      [attr.space-between]="4"
      [attr.observer]="true"
      [attr.observe-parents]="true"
      style="display: block; width: 100%">
      @for (image of validImages; track $index) {
      <swiper-slide>
        <div style="cursor: pointer; position: relative; width: 200px; margin: 0 auto;"
             (click)="onClickImagem(image.index)">
          <img [src]="image.thumbImage"
               style="width: 200px; height: 125px; object-fit: contain; display: block;">
          <div class="caption"
               style="position: absolute; bottom: 0; left: 0; right: 0;
                      font-size: 11px; padding: 4px; color: white; text-align: center;
                      background: linear-gradient(to right, rgba(0,0,0,.6), rgba(0,0,0,.6), rgba(0,0,0,.6), rgba(0,0,0,.6), rgba(0,0,0,.6));
                      word-break: break-word;">
            {{ image.title }}
          </div>
        </div>
      </swiper-slide>
      }
    </swiper-container>
  </div>
  }
</div>
